function createInputForProductForm(label, value="") {
  
  const div = document.createElement('div');
  div.className = 'product__property we-hide';

  const input = document.createElement('input');
  input.type = 'text';
  input.id = `property-${label}`;
  input.name = `properties[${label}]`;
  input.value = value;
  input.className = 'property-field';
  input.type = "hidden"

  div.appendChild(input);
  
  return {wrapper: div, input: input};
}

function addNodeToBuyForm(node){
    const buyForm = document.querySelector('.we-buy-form');
    if(buyForm){
        buyForm.appendChild(node);
    }
}

window.wesite = {...window.wesite}
window.wesite.propertyInput = {
  createInputForProductForm: createInputForProductForm,
  addNodeToBuyForm: addNodeToBuyForm
}